import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationDialog from '../common/ConfirmationDialog';

function RequestRefreshDialog({ open, title, message, buttonText, hideCancel, conflicts, onConfirm }) {
  if (!open) return null;

  return (
    <ConfirmationDialog
      open={open}
      onClose={onConfirm}
      title={title}
      okText={buttonText}
      cancel={!hideCancel}
      titlestyles={{ textAlign: 'left' }}
      contentstyles={{ padding: '0 24px 0 24px' }}
    >
      {message}
      {conflicts.length > 0 && (
        <>
          <p>The following changes you have not saved yet could not be refreshed automatically:</p>
          <ul>
            {conflicts.map(conflict => (
              <li key={conflict}>{conflict}</li>
            ))}
          </ul>
        </>
      )}
    </ConfirmationDialog>
  );
}

RequestRefreshDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  hideCancel: PropTypes.bool,
  conflicts: PropTypes.arrayOf(PropTypes.string),
  onConfirm: PropTypes.func.isRequired,
};

RequestRefreshDialog.defaultProps = {
  hideCancel: false,
  conflicts: [],
};

export default RequestRefreshDialog;
